import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Evenementiel = () => {
  const sectorData = {
    title: "Événementiel",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Agences, plateformes ou prestataires techniques doivent toucher les directions marketing, communication et RH avec des messages centrés sur la mémorabilité, la gestion opérationnelle et l'impact. Un bon mix visuels, webinaires et cas concrets est clé.",
    name: "Événementiel",
    titleContext: "du secteur événementiel",
    responseContext: "du secteur événementiel",
    expertContext: "du secteur événementiel"
  };

  return <SectorPage sector={sectorData} />;
};

export default Evenementiel; 